export const countryOptions = [
  { value: 'KR', label: '🇰🇷 KR +82', flag: '🇰🇷', code: '+82' },
  { value: 'US', label: '🇺🇸 US +1', flag: '🇺🇸', code: '+1' },
  { value: 'JP', label: '🇯🇵 JP +81', flag: '🇯🇵', code: '+81' },
  { value: 'CN', label: '🇨🇳 CN +86', flag: '🇨🇳', code: '+86' },
  { value: 'TW', label: '🇹🇼 TW +886', flag: '🇹🇼', code: '+886' },
  { value: 'SG', label: '🇸🇬 SG +65', flag: '🇸🇬', code: '+65' },
  { value: 'PH', label: '🇵🇭 PH +63', flag: '🇵🇭', code: '+63' },
  { value: 'TH', label: '🇹🇭 TH +66', flag: '🇹🇭', code: '+66' },
];
